"use strict";

(function(window) {

	Vue.component('autocomplete-tests', {

		props: {
			'tests': {
				type: Array,
				required: false,
				default: () => [],
			},
			'value': {
				type: String
			}
		},

		template: `
			<div class="input-group autocomplete-input">
			
				<input type="text"
					class="search-bar form-control" 
					v-model="search"
					@input="onChange($event.target.value)"
					@keydown.down="onArrowDown"
					@keydown.up="onArrowUp"
					@keydown.enter="onEnter"
					placeholder="Search a Test Code"
					autocomplete="off"
				/>
				
				<ul class="autocomplete-results">
					<li 
						v-for="(result, i) in results.slice(0, 5)"
						v-show="isOpen" 
						:key="i" 
						class="autocomplete-result" 
						@click="setResult(result)" 
						:class="{ 'is-active': i === arrowCounter }"
						tabindex="0"
						@keypress.enter="setResult(result)"
					>
						{{ result | capitalize }}
					</li>
				</ul>
				
				<div class="input-group-append"></div>
				
			</div>
		`,

		name: 'autocomplete-tests',

		data() {
			return {
				search: '',
				result: '',
				results: [],
				isOpen: false,
				arrowCounter: -1,
			};
		},

		mounted() {
			document.addEventListener('click', this.handleClickOutside);
		},

		destroyed() {
			document.removeEventListener('click', this.handleClickOutside);
		},

		filters: {
			capitalize: function (value) {
				if (!value) return ''
				value = value.toString()
				return value.charAt(0).toUpperCase() + value.slice(1)
			}
		},

		methods: {
			onChange(value) {
				this.isOpen = true;
				this.$emit('input', value);
				this.filterResults();
			},
			filterResults() {
				this.results = this.tests.filter(code => code.toLowerCase().indexOf(this.search.toLowerCase()) > -1);
			},
			onArrowDown() {
				if (this.arrowCounter < this.results.length) {
					this.arrowCounter = this.arrowCounter + 1;
				}
			},
			onArrowUp() {
				if (this.arrowCounter > 0) {
					this.arrowCounter = this.arrowCounter - 1;
				}
			},
			onEnter() {
				let self = this;
				if(this.results[self.arrowCounter] !== undefined){
					this.result = this.results[this.arrowCounter].toLowerCase();
					this.search = this.result;
					this.isOpen = false;
					this.$emit('input', this.search);
					this.arrowCounter = -1;
					this.$emit('searchCode', true);
				}
				else{
					this.search = this.search.toLowerCase();
					this.isOpen = false;
					this.$emit('input', this.search);
					this.arrowCounter = -1;
					this.$emit('searchCode', true);
				}
			},
			setResult(result) {
				this.search = result.toLowerCase();
				this.isOpen = false;
				this.$emit('input', this.search);
				this.$emit('searchCode', true);
			},
			updateValue: function (value) {
				this.$emit(this.search);
			},
			handleClickOutside(event) {
				if (!this.$el.contains(event.target)) {
					this.isOpen = false;
					this.arrowCounter = -1;
				}
			},
			resetResult(){
				this.search= '';
			}
		}

	});

})(window);
